import {
    COMMERCIAL_TICKET_STATUS_IN_PROGRESS_DEALER,
    COMMERCIAL_TICKET_STATUS_IN_PROGRESS_SUBSIDIARY,
    COMMERCIAL_TICKET_STATUS_NEW,
    COMMERCIAL_TICKET_STATUS_REOPEN, COMMERCIAL_TICKET_STATUS_WORK_IN_PROGRESS
} from './formConstants';

export const editCommercialListButtonVisibility = {
    DEALER: [
        COMMERCIAL_TICKET_STATUS_IN_PROGRESS_DEALER,
        COMMERCIAL_TICKET_STATUS_WORK_IN_PROGRESS,
    ],
    EDITOR: [
        COMMERCIAL_TICKET_STATUS_NEW,
        COMMERCIAL_TICKET_STATUS_IN_PROGRESS_SUBSIDIARY,
        COMMERCIAL_TICKET_STATUS_IN_PROGRESS_DEALER,
        COMMERCIAL_TICKET_STATUS_WORK_IN_PROGRESS,
        COMMERCIAL_TICKET_STATUS_REOPEN
    ]
};

export const createRights = {
    // dealer section
    canShowDealerSection: false,
    // ticket section
    canEditSubject: true,
    canEditPriority: true,
    canEditBrand: true,
    canEditModel: true,
    canEditVersion: true,
    canEditVin: true,
    canEditOrderNumber: true,
    canEditOption: true,
    canEditDhs: true,
    canOpenFrequentQuestion: true,
    // offer for employees section
    canEditTypeOfPurchase:true,
    canEditEmployeeOf:true,
    canEditNameAndSurnameOfTheEmployee:true,
    canEditNoOfTheEmployeeEligibleForADiscount:true,
    canEditNameAndSurnameOfThePerson:true,
    // message section
    canShowAutomaticResponse: false,
    canAddMessage: true,
    canAddSendCopyTo: true,
    // attachment section
    canAddAttach: true,
    // buttons
    canSave: true,
    canClose: false,
    canForwardToDealer: false,
    canForwardToNPDC: false,
    canWorkInProgress: false,
    canReopen: false,
    canSkipModalReopen: false,
};

export const editRights = {
    DEALER: {
        NEW: {
            // dealer section
            canShowDealerSection: true,
            // ticket section
            canEditSubject: false,
            canEditPriority: false,
            canEditBrand: false,
            canEditModel: false,
            canEditVersion: false,
            canEditVin: false,
            canEditOrderNumber: false,
            canEditOption: false,
            canEditDhs: false,
            canOpenFrequentQuestion: false,
            // offer for employees section
            canEditTypeOfPurchase:false,
            canEditEmployeeOf:false,
            canEditNameAndSurnameOfTheEmployee:false,
            canEditNoOfTheEmployeeEligibleForADiscount:false,
            canEditNameAndSurnameOfThePerson:false,
            // message section
            canShowAutomaticResponse: false,
            canAddMessage: false,
            canAddSendCopyTo: false,
            // attachment section
            canAddAttach: false,
            // buttons
            canSave: false,
            canClose: false,
            canForwardToDealer: false,
            canForwardToNPDC: false,
            canWorkInProgress: false,
            canReopen: false,
            canSkipModalReopen: false,
        },
        CLOSED: {
            // dealer section
            canShowDealerSection: true,
            // ticket section
            canEditSubject: false,
            canEditPriority: false,
            canEditBrand: false,
            canEditModel: false,
            canEditVersion: false,
            canEditVin: false,
            canEditOrderNumber: false,
            canEditOption: false,
            canEditDhs: false,
            canOpenFrequentQuestion: false,
            // offer for employees section
            canEditTypeOfPurchase:false,
            canEditEmployeeOf:false,
            canEditNameAndSurnameOfTheEmployee:false,
            canEditNoOfTheEmployeeEligibleForADiscount:false,
            canEditNameAndSurnameOfThePerson:false,
            // message section
            canShowAutomaticResponse: false,
            canAddMessage: false,
            canAddSendCopyTo: false,
            // attachment section
            canAddAttach: false,
            // buttons
            canSave: false,
            canClose: false,
            canForwardToDealer: false,
            canForwardToNPDC: false,
            canWorkInProgress: false,
            canReopen: true,
            canSkipModalReopen: false,
        },
        WAIT_SUBSIDIARY: {
            // dealer section
            canShowDealerSection: true,
            // ticket section
            canEditSubject: false,
            canEditPriority: false,
            canEditBrand: false,
            canEditModel: false,
            canEditVersion: false,
            canEditVin: false,
            canEditOrderNumber: false,
            canEditOption: false,
            canEditDhs: false,
            canOpenFrequentQuestion: false,
            // offer for employees section
            canEditTypeOfPurchase:false,
            canEditEmployeeOf:false,
            canEditNameAndSurnameOfTheEmployee:false,
            canEditNoOfTheEmployeeEligibleForADiscount:false,
            canEditNameAndSurnameOfThePerson:false,
            // message section
            canShowAutomaticResponse: false,
            canAddMessage: false,
            canAddSendCopyTo: false,
            // attachment section
            canAddAttach: false,
            // buttons
            canSave: false,
            canClose: false,
            canForwardToDealer: false,
            canForwardToNPDC: false,
            canWorkInProgress: false,
            canReopen: false,
            canSkipModalReopen: false,
        },
        WAIT_DEALER: {
            // dealer section
            canShowDealerSection: true,
            // ticket section field
            canEditSubject: false,
            canEditPriority: false,
            canEditBrand: false,
            canEditModel: false,
            canEditVersion: false,
            canEditVin: false,
            canEditOrderNumber: false,
            canEditOption: false,
            canEditDhs: false,
            canOpenFrequentQuestion: false,
            // offer for employees section
            canEditTypeOfPurchase:false,
            canEditEmployeeOf:false,
            canEditNameAndSurnameOfTheEmployee:false,
            canEditNoOfTheEmployeeEligibleForADiscount:false,
            canEditNameAndSurnameOfThePerson:false,
            // message section
            canShowAutomaticResponse: false,
            canAddMessage: true,
            canAddSendCopyTo: true,
            // attachment section
            canAddAttach: true,
            // buttons
            canSave: false,
            canClose: false,
            canForwardToDealer: false,
            canForwardToNPDC: true,
            canWorkInProgress: false,
            canReopen: false,
            canSkipModalReopen: false,
        },
        WAIT_WORK_IN_PROGRESS: {
            // dealer section
            canShowDealerSection: true,
            // ticket section field
            canEditSubject: false,
            canEditPriority: false,
            canEditBrand: false,
            canEditModel: false,
            canEditVersion: false,
            canEditVin: false,
            canEditOrderNumber: false,
            canEditOption: false,
            canEditDhs: false,
            canOpenFrequentQuestion: false,
            // offer for employees section
            canEditTypeOfPurchase:false,
            canEditEmployeeOf:false,
            canEditNameAndSurnameOfTheEmployee:false,
            canEditNoOfTheEmployeeEligibleForADiscount:false,
            canEditNameAndSurnameOfThePerson:false,
            // message section
            canShowAutomaticResponse: false,
            canAddMessage: true,
            canAddSendCopyTo: true,
            // attachment section
            canAddAttach: false,
            // buttons
            canSave: true,
            canClose: false,
            canForwardToDealer: false,
            canForwardToNPDC: false,
            canWorkInProgress: false,
            canReopen: false,
            canSkipModalReopen: false,
        },
        REOPEN: {
            // dealer section
            canShowDealerSection: true,
            // ticket section
            canEditSubject: false,
            canEditPriority: false,
            canEditBrand: false,
            canEditModel: false,
            canEditVersion: false,
            canEditVin: false,
            canEditOrderNumber: false,
            canEditOption: false,
            canEditDhs: false,
            canOpenFrequentQuestion: false,
            // offer for employees section
            canEditTypeOfPurchase:false,
            canEditEmployeeOf:false,
            canEditNameAndSurnameOfTheEmployee:false,
            canEditNoOfTheEmployeeEligibleForADiscount:false,
            canEditNameAndSurnameOfThePerson:false,
            // message section
            canShowAutomaticResponse: false,
            canAddMessage: false,
            canAddSendCopyTo: false,
            // attachment section
            canAddAttach: false,
            // buttons
            canSave: false,
            canClose: false,
            canForwardToDealer: false,
            canForwardToNPDC: false,
            canWorkInProgress: false,
            canReopen: false,
            canSkipModalReopen: false,
        }
    },
    EDITOR: {
        NEW: {
            // dealer section
            canShowDealerSection: true,
            // ticket section
            canEditSubject: false,
            canEditPriority: false,
            canEditBrand: false,
            canEditModel: false,
            canEditVersion: false,
            canEditVin: false,
            canEditOrderNumber: false,
            canEditOption: false,
            canEditDhs: false,
            canOpenFrequentQuestion: false,
            // offer for employees section
            canEditTypeOfPurchase:false,
            canEditEmployeeOf:false,
            canEditNameAndSurnameOfTheEmployee:false,
            canEditNoOfTheEmployeeEligibleForADiscount:false,
            canEditNameAndSurnameOfThePerson:false,
            // message section
            canShowAutomaticResponse: true,
            canAddMessage: true,
            canAddSendCopyTo: true,
            // attachment section
            canAddAttach: true,
            // buttons
            canSave: false,
            canClose: true,
            canForwardToDealer: true,
            canForwardToNPDC: false,
            canWorkInProgress: true,
            canReopen: false,
            canSkipModalReopen: false,
        },
        CLOSED: {
            // dealer section
            canShowDealerSection: true,
            // ticket section
            canEditSubject: false,
            canEditPriority: false,
            canEditBrand: false,
            canEditModel: false,
            canEditVersion: false,
            canEditVin: false,
            canEditOrderNumber: false,
            canEditOption: false,
            canEditDhs: false,
            canOpenFrequentQuestion: false,
            // offer for employees section
            canEditTypeOfPurchase:false,
            canEditEmployeeOf:false,
            canEditNameAndSurnameOfTheEmployee:false,
            canEditNoOfTheEmployeeEligibleForADiscount:false,
            canEditNameAndSurnameOfThePerson:false,
            // message section
            canShowAutomaticResponse: false,
            canAddMessage: false,
            canAddSendCopyTo: false,
            // attachment section
            canAddAttach: false,
            // buttons
            canSave: false,
            canClose: false,
            canForwardToDealer: false,
            canForwardToNPDC: false,
            canWorkInProgress: false,
            canReopen: false,
            canSkipModalReopen: true,
        },
        WAIT_SUBSIDIARY: {
            // dealer section
            canShowDealerSection: true,
            // ticket section
            canEditSubject: false,
            canEditPriority: false,
            canEditBrand: false,
            canEditModel: false,
            canEditVersion: false,
            canEditVin: false,
            canEditOrderNumber: false,
            canEditOption: false,
            canEditDhs: false,
            canOpenFrequentQuestion: false,
            // offer for employees section
            canEditTypeOfPurchase:false,
            canEditEmployeeOf:false,
            canEditNameAndSurnameOfTheEmployee:false,
            canEditNoOfTheEmployeeEligibleForADiscount:false,
            canEditNameAndSurnameOfThePerson:false,
            // message section
            canShowAutomaticResponse: true,
            canAddMessage: true,
            canAddSendCopyTo: true,
            // attachment section
            canAddAttach: true,
            // buttons
            canSave: false,
            canClose: true,
            canForwardToDealer: true,
            canForwardToNPDC: false,
            canWorkInProgress: true,
            canReopen: false,
            canSkipModalReopen: false,
        },
        WAIT_DEALER: {
            // dealer section
            canShowDealerSection: true,
            // ticket section
            canEditSubject: false,
            canEditPriority: false,
            canEditBrand: false,
            canEditModel: false,
            canEditVersion: false,
            canEditVin: false,
            canEditOrderNumber: false,
            canEditOption: false,
            canEditDhs: false,
            canOpenFrequentQuestion: false,
            // offer for employees section
            canEditTypeOfPurchase:false,
            canEditEmployeeOf:false,
            canEditNameAndSurnameOfTheEmployee:false,
            canEditNoOfTheEmployeeEligibleForADiscount:false,
            canEditNameAndSurnameOfThePerson:false,
            // message section
            canShowAutomaticResponse: true,
            canAddMessage: true,
            canAddSendCopyTo: true,
            // attachment section
            canAddAttach: true,
            // buttons
            canSave: true,
            canClose: true,
            canForwardToDealer: false,
            canForwardToNPDC: false,
            canWorkInProgress: true,
            canReopen: false,
            canSkipModalReopen: false,
        },
        WAIT_WORK_IN_PROGRESS: {
            // dealer section
            canShowDealerSection: true,
            // ticket section
            canEditSubject: false,
            canEditPriority: false,
            canEditBrand: false,
            canEditModel: false,
            canEditVersion: false,
            canEditVin: false,
            canEditOrderNumber: false,
            canEditOption: false,
            canEditDhs: false,
            canOpenFrequentQuestion: false,
            // offer for employees section
            canEditTypeOfPurchase:false,
            canEditEmployeeOf:false,
            canEditNameAndSurnameOfTheEmployee:false,
            canEditNoOfTheEmployeeEligibleForADiscount:false,
            canEditNameAndSurnameOfThePerson:false,
            // message section
            canShowAutomaticResponse: true,
            canAddMessage: true,
            canAddSendCopyTo: true,
            // attachment section
            canAddAttach: true,
            // buttons
            canSave: true,
            canClose: true,
            canForwardToDealer: true,
            canForwardToNPDC: false,
            canWorkInProgress: false,
            canReopen: false,
            canSkipModalReopen: false,
        },
        REOPEN: {
            // dealer section
            canShowDealerSection: true,
            // ticket section
            canEditSubject: false,
            canEditPriority: false,
            canEditBrand: false,
            canEditModel: false,
            canEditVersion: false,
            canEditVin: false,
            canEditOrderNumber: false,
            canEditOption: false,
            canEditDhs: false,
            canOpenFrequentQuestion: false,
            // offer for employees section
            canEditTypeOfPurchase:false,
            canEditEmployeeOf:false,
            canEditNameAndSurnameOfTheEmployee:false,
            canEditNoOfTheEmployeeEligibleForADiscount:false,
            canEditNameAndSurnameOfThePerson:false,
            // message section
            canShowAutomaticResponse: true,
            canAddMessage: true,
            canAddSendCopyTo: true,
            // attachment section
            canAddAttach: true,
            // buttons
            canSave: false,
            canClose: true,
            canForwardToDealer: true,
            canForwardToNPDC: false,
            canWorkInProgress: true,
            canReopen: false,
            canSkipModalReopen: false,
        }
    }
};
